import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f930008"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "skills p-mt-0",
  "data-cy": "profile-view-skills"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { "data-cy": "wizard-view-jobtitle-dropdown" }
const _hoisted_4 = { class: "p-no-float-label" }
const _hoisted_5 = {
  key: 0,
  "data-cy": "wizard-view-jobtitle-dropdown-value",
  class: "tags"
}
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "p-no-float-label" }
const _hoisted_10 = {
  key: 0,
  "data-cy": "profile-view-competence-value",
  class: "tags"
}
const _hoisted_11 = {
  key: 1,
  class: "p-error"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "p-no-float-label" }
const _hoisted_14 = {
  key: 0,
  "data-cy": "profile-view-competence-value",
  class: "tags"
}
const _hoisted_15 = {
  key: 1,
  class: "p-error"
}
const _hoisted_16 = { class: "p-no-float-label" }
const _hoisted_17 = {
  key: 0,
  "data-cy": "profile-view-competence-value",
  class: "tags"
}
const _hoisted_18 = {
  key: 1,
  class: "p-error"
}
const _hoisted_19 = {
  key: 0,
  class: "call-to-action mobile-bottom-nav"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))

import { ref, computed } from "vue";
    import MultiSelect from "primevue/multiselect";
    import Checklist from "../CheckList.vue";
    import { CandidateProfile } from "@/models/CandidateProfile";
    import { Skill } from "@/models/Skill";
    import { AreaOfExpertise } from "@/models/AreaOfExpertise";
    import { JobTitle } from "@/models/JobTitle";
    import useVuelidate from "@vuelidate/core";
    import { helpers, requiredIf } from "@vuelidate/validators";
    import { useI18n } from "vue-i18n";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ExpertiseAndSkill',
  props: {
    candidate: {},
    availableSkills: {},
    availableExpertises: {},
    availableJobTitles: {},
    showButtons: { type: Boolean }
  },
  emits: ["next", "previous", "skillValidityChanged", "keySkillValidityChanged"],
  setup(__props: any, { emit: __emit }) {

    const emit = __emit;
    const props = __props;

    const { t } = useI18n();

    function compare(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    const availableJobTitlesOptions = [...props.availableJobTitles];
    availableJobTitlesOptions.forEach(option => {
        option.name = t(option.name)
    });
    availableJobTitlesOptions.sort(compare)


    const editableCandidate = ref(props.candidate);

    const originalSkillIDs = editableCandidate.value.skills.map(
        (skill) => skill.id
    );

    const originalKeySkillIDs = editableCandidate.value.keySkills.map(
        (skill) => skill.id
    );

    const rules = {
        jobTitles: {},
        areasOfExpertise: {},
        skills: {},
        keySkills: {
            requiredIf: helpers.withMessage(t("validate.required.practicearea"), requiredIf(() => {
                return containsLawyer.value;
            }))
        },
    };

    const expertiseOptions = computed(() => {
        let result: AreaOfExpertise[];

        result = props.availableExpertises;
        result.forEach(option => {
            option.name = t(option.name)
        });

        return result;
    });

    const skillOptions = computed(() => {
        let result: Skill[];
        const aoes = editableCandidate.value.areasOfExpertise;
        const aoeIDs = aoes.map((aoe) => aoe.id);

        result = props.availableSkills.filter(
            (skill) =>
                !skill.areaOfExpertiseId || aoeIDs.indexOf(skill.areaOfExpertiseId) > -1
        );

        result.forEach(option => {
            option.name = t(option.name)
        });

        result.sort(compare);

        return result;
    });

    const aoeSelection = computed({
        get: () => {
            if (!editableCandidate.value) {
                return [] as AreaOfExpertise[];
            }
            let result: AreaOfExpertise[] = [];
            const aoeIDs = editableCandidate.value.areasOfExpertise.map(
                (aoe) => aoe.id
            );

            result = expertiseOptions.value.filter(
                (option) => aoeIDs.indexOf(option.id) > -1
            );
            return result;
        },
        set: (value) => {
            editableCandidate.value.areasOfExpertise = value;
            removeInvalidSkills();
        },
    });

    const keySkillOptions = ref(skillOptions.value.filter(x => x.isKeySkill));
    const notKeySkillOptions = ref(skillOptions.value.filter(x => !x.isKeySkill));
    const containsLawyer = ref(editableCandidate.value.jobTitles.find(e => e.id === 9 || e.id === 565) != null);
    const onChange = () => {
        keySkillOptions.value = props.availableSkills.filter(x => x.isKeySkill);
        notKeySkillOptions.value = props.availableSkills.filter(x => !x.isKeySkill);
        containsLawyer.value = editableCandidate.value.jobTitles.find(e => e.id === 9 || e.id === 565) != null;
        if (containsLawyer.value) {
            if (!editableCandidate.value.areasOfExpertise.find(x => x.id === props.availableExpertises[2].id))
                editableCandidate.value.areasOfExpertise.push(props.availableExpertises[2]);
        }
    }

    const removeInvalidSkills = () => {
        const aoeIDs = editableCandidate.value.areasOfExpertise.map((aoe) => aoe.id);
        editableCandidate.value.skills = editableCandidate.value.skills.filter(
            (skill) =>
                skill.areaOfExpertiseId && aoeIDs.indexOf(skill.areaOfExpertiseId) > -1
        );
        determineSkillValidity();
    };

    function determineSkillValidity() {
        const currentSkillIDs = editableCandidate.value.skills.map(
            (skill) => skill.id
        );
        const valid =
            originalSkillIDs.filter((origID) => currentSkillIDs.indexOf(origID) < 0)
                .length > 0;
        emit("skillValidityChanged", valid);
    }

    function determineKeySkillValidity() {
        const currentSkillIDs = editableCandidate.value.keySkills.map(
            (skill) => skill.id
        );
        const valid =
            originalKeySkillIDs.filter((origID) => currentSkillIDs.indexOf(origID) < 0)
                .length > 0;
        emit("keySkillValidityChanged", valid);
    }

    const canSelectSkills = computed(() => {
        return editableCandidate.value?.jobTitles?.length > 0;
    });

    const v$ = useVuelidate(rules, editableCandidate);

    function handleSkillRemoval(event, id: number) {
        editableCandidate.value.skills = editableCandidate.value.skills.filter(
            (skill) => skill.id != id
        );
        determineSkillValidity();
    }

    function handleKeySkillRemoval(event, id: number) {
        editableCandidate.value.keySkills = editableCandidate.value.keySkills.filter(
            (skill) => skill.id != id
        );
        determineKeySkillValidity();
    }

    const handleJobTitleRemoval = async (event, jobTitle: JobTitle) => {
        editableCandidate.value.jobTitles =
            editableCandidate?.value?.jobTitles.filter(
                (element) => element.id != jobTitle.id
            );
        onChange();
    };

    const validate = () => {
        v$.value.$touch();
        return v$.value.$error;
    };
    const next = () => {
        if (!validate()) {
            emit("next", editableCandidate.value);
        }
    };

    const prev = () => {
        emit("previous", editableCandidate.value);
    };

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createElementVNode("h5", null, _toDisplayString(_unref(t)("please.choose.mainareasofexpertise")), 1),
        _createVNode(Checklist, {
          modelValue: aoeSelection.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((aoeSelection).value = $event)),
          options: expertiseOptions.value,
          optionLabel: "name",
          "data-cy": "wizard-expertise-option"
        }, null, 8, ["modelValue", "options"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).areasOfExpertise.$errors, (error, index) => {
          return (_openBlock(), _createElementBlock("small", {
            "data-cy": "wizard-expertise-option-error",
            class: "p-error",
            key: index
          }, _toDisplayString(error.$message), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          (editableCandidate.value.jobTitles && editableCandidate.value.jobTitles.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.jobTitles, (job) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: job.id
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)(job.name)) + " ", 1),
                    _createVNode(_component_Button, {
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-outlined skills__remove",
                      onClick: ($event: any) => (handleJobTitleRemoval($event, job)),
                      "data-cy": "wizard-jobtitle-selected"
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h5", null, _toDisplayString(_unref(t)("please.choose.jobtitle")), 1),
          _createVNode(_unref(MultiSelect), {
            modelValue: _unref(v$).jobTitles.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).jobTitles.$model) = $event)),
            display: "none",
            filter: true,
            autoFilterFocus: true,
            filterIcon: "pi pi-search",
            class: _normalizeClass({ 'p-invalid': _unref(v$).jobTitles.$error }),
            options: availableJobTitlesOptions,
            optionLabel: _unref(t)('name'),
            showToggleAll: false,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (onChange())),
            "data-cy": "wizard-choose-jobtitle"
          }, null, 8, ["modelValue", "class", "optionLabel"]),
          _createElementVNode("label", null, _toDisplayString(_unref(t)("current.job.title")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).jobTitles.$errors, (error, index) => {
            return (_openBlock(), _createElementBlock("small", {
              "data-cy": "wizard-view-jobtitle-dropdown-error",
              class: "p-error p-mt-0",
              key: index
            }, _toDisplayString(_unref(t)(error.$message)), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (canSelectSkills.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!containsLawyer.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h5", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("please.choose.competencesandskills")) + " ", 1),
                    _createVNode(_component_Tooltip, {
                      message: _unref(t)('expertise.and.skill.tooltip.message2')
                    }, null, 8, ["message"])
                  ]),
                  _createElementVNode("span", _hoisted_9, [
                    (editableCandidate.value?.skills && editableCandidate.value.skills.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.skills, (skill) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: skill.name
                            }, [
                              _createTextVNode(_toDisplayString(skill.name) + " ", 1),
                              _createVNode(_component_Button, {
                                icon: "pi pi-times",
                                class: "p-button-rounded p-button-outlined skills__remove",
                                onClick: ($event: any) => (handleSkillRemoval($event, skill.id)),
                                "data-cy": "wizard-competences-chosen"
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(MultiSelect), {
                      modelValue: _unref(v$).skills.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).skills.$model) = $event)),
                      options: skillOptions.value,
                      filter: true,
                      autoFilterFocus: true,
                      filterIcon: "pi pi-search",
                      display: "none",
                      disabled: !canSelectSkills.value,
                      class: _normalizeClass({ 'p-invalid': _unref(v$).skills.$error }),
                      onChange: determineSkillValidity,
                      optionLabel: "name",
                      showToggleAll: false,
                      "data-cy": "wizard-competences-options"
                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("add.competence")), 1),
                    (!canSelectSkills.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_unref(t)("please.choose.subjectarea")), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).skills.$errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("small", {
                        "data-cy": "wizard-competences-options-error",
                        class: "p-error p-mt-0",
                        key: index
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("h5", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("please.choose.skills")) + " ", 1),
                    _createVNode(_component_Tooltip, {
                      message: _unref(t)('expertise.and.skill.tooltip.message2')
                    }, null, 8, ["message"])
                  ]),
                  _createElementVNode("span", _hoisted_13, [
                    (editableCandidate.value?.keySkills && editableCandidate.value.keySkills.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.keySkills, (skill) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: skill.name
                            }, [
                              _createTextVNode(_toDisplayString(skill.name) + " ", 1),
                              _createVNode(_component_Button, {
                                icon: "pi pi-times",
                                class: "p-button-rounded p-button-outlined skills__remove",
                                onClick: ($event: any) => (handleKeySkillRemoval($event, skill.id)),
                                "data-cy": "wizard-competences-chosen"
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(MultiSelect), {
                      modelValue: _unref(v$).keySkills.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).keySkills.$model) = $event)),
                      options: keySkillOptions.value,
                      filter: true,
                      autoFilterFocus: true,
                      filterIcon: "pi pi-search",
                      display: "none",
                      disabled: !canSelectSkills.value,
                      class: _normalizeClass({ 'p-invalid': _unref(v$).keySkills.$error }),
                      onChange: determineSkillValidity,
                      optionLabel: "name",
                      showToggleAll: false,
                      "data-cy": "wizard-competences-options"
                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("add.practicearea")), 1),
                    (!canSelectSkills.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_unref(t)("please.choose.subjectarea")), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).keySkills.$errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("small", {
                        "data-cy": "wizard-competences-options-error",
                        class: "p-error p-mt-0",
                        key: index
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ]),
                  _createElementVNode("h5", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("please.choose.competencesandskills")) + " ", 1),
                    _createVNode(_component_Tooltip, {
                      message: _unref(t)('expertise.and.skill.tooltip.message2')
                    }, null, 8, ["message"])
                  ]),
                  _createElementVNode("span", _hoisted_16, [
                    (editableCandidate.value?.skills && editableCandidate.value.skills.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableCandidate.value.skills.filter(x => !x.isKeySkill), (skill) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: skill.name
                            }, [
                              _createTextVNode(_toDisplayString(skill.name) + " ", 1),
                              _createVNode(_component_Button, {
                                icon: "pi pi-times",
                                class: "p-button-rounded p-button-outlined skills__remove",
                                onClick: ($event: any) => (handleSkillRemoval($event, skill.id)),
                                "data-cy": "wizard-competences-chosen"
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(MultiSelect), {
                      modelValue: _unref(v$).skills.$model,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).skills.$model) = $event)),
                      options: notKeySkillOptions.value,
                      filter: true,
                      autoFilterFocus: true,
                      filterIcon: "pi pi-search",
                      display: "none",
                      disabled: !canSelectSkills.value,
                      class: _normalizeClass({ 'p-invalid': _unref(v$).skills.$error }),
                      onChange: determineSkillValidity,
                      optionLabel: "name",
                      showToggleAll: false,
                      "data-cy": "wizard-competences-options"
                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("add.competence")), 1),
                    (!canSelectSkills.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_unref(t)("please.choose.subjectarea")), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).skills.$errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("small", {
                        "data-cy": "wizard-competences-options-error",
                        class: "p-error p-mt-0",
                        key: index
                      }, _toDisplayString(error.$message), 1))
                    }), 128))
                  ])
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showButtons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_Button, {
            "data-cy": "button-profile-prev",
            class: "button-secondary button-back p-pl-3",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (prev()))
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _createTextVNode(_toDisplayString(_unref(t)("back")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            "data-cy": "button-profile-next",
            class: "button-secondary button-next p-pr-3",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (next()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("continue")) + " ", 1),
              _hoisted_21
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})